// extracted by mini-css-extract-plugin
export default {"modalOverlay":"XE-z","modalContent":"YE-z","header":"ZE-z","close":"_E-z"};